import React, { forwardRef, useState, useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import br from 'date-fns/locale/pt-BR';
registerLocale('br', br);

const DateTimeField = forwardRef((props, ref) => {
    let initialDateTimeValue = '';

    if (props.value && props.value !== '') {
        initialDateTimeValue = moment(props.value).toDate();
    } else if (props.defaultValue && props.defaultValue !== '') {
        initialDateTimeValue = moment(props.defaultValue).toDate();
    }

    const [value, setValue] = useState(initialDateTimeValue);
    const className = props.error ? 'form-control is-invalid' : 'form-control';
    
    useEffect(() => {
        if (props.defaultValue && props.defaultValue !== '' && !props.value) {
            const defaultMoment = moment(props.defaultValue).toDate();
            setValue(defaultMoment);
            handleChange(defaultMoment);
        }
    }, [props.defaultValue]);

    const handleChange = (element) => {
        let data = '';
        if (moment(element).isValid()) {
            data = moment(element).format('YYYY-MM-DD HH:mm:ss.SSS');
        }
        const target = {
            name: props.name,
            type: 'datetime',
            value: moment(element).valueOf(),
        };
        setValue(element);
        props.onChange({ target: target });
    };

    return (
        <div ref={ref}>
            {!props.readOnly && (
                <div>
                    <DatePicker
                        id={'id_' + props.name}
                        name={props.name}
                        selected={value}
                        onChange={handleChange}
                        locale="br"
                        dateFormat="dd/MM/yyyy HH:mm"
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat="HH:mm"
                        strictParsing
                        className={className}
                        autoFocus={props.autoFocus}
                    />
                </div>
            )}

            {props.readOnly && value && (
                <span>{moment(value).format('DD/MM/YYYY HH:mm')}</span>
            )}

            {props.error && (
                <span className="error invalid-feedback" style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
});

export default DateTimeField;